/** @jsx jsx */

import { Fragment } from 'react';

import {
  Button,
  Colors,
  Img,
  Spacer,
  Text,
  ToggleSwitch,
  ZapierLogoSymbol,
} from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import { PLACEHOLDER_SRC_OLD } from 'app/developer-v3/constants';

import type { PartnerProfile } from 'app/developer-v3/types/partnerProfile';

const Styles = {
  buttonWrapper: css`
    display: flex;
    margin-top: 20px;
    justify-content: flex-end;
  `,
  logoWrapper: css`
    width: 45px;
    height: 45px;
  `,
  membership: css`
    align-items: center;
    border-top: 1px solid ${Colors.GrayWarm4};
    &:last-of-type {
      border-bottom: 1px solid ${Colors.GrayWarm4};
    }
    display: flex;
    justify-content: space-between;
    padding: 15px 20px;
  `,
  membershipInfo: css`
    display: inline-flex;
    align-items: center;
  `,
};

type Membership = PartnerProfile['memberships'][0];
type Props = {
  memberships: Membership[];
  onClickAllMembership: () => Promise<void>;
  onToggleMembership: (membership: Membership) => Promise<void>;
};

function Memberships({
  memberships,
  onClickAllMembership,
  onToggleMembership,
}: Props) {
  const isEveryMembershipOff = memberships.every(({ optedIn }) => !optedIn);

  return (
    <Fragment>
      <ul>
        {memberships.map(membership => (
          <li css={Styles.membership} key={membership.app.id}>
            <div css={Styles.membershipInfo}>
              {membership.app.image === PLACEHOLDER_SRC_OLD ? (
                <ZapierLogoSymbol />
              ) : (
                <Img
                  alt={membership.app.title}
                  height={45}
                  src={membership.app.image}
                  width={45}
                />
              )}
              <Spacer width={40} />
              <Text fontWeight={600}>{membership.app.title}</Text>
            </div>
            <ToggleSwitch
              checked={membership.optedIn}
              onChange={() => onToggleMembership(membership)}
            />
          </li>
        ))}
      </ul>
      <div css={Styles.buttonWrapper}>
        <Button onPress={onClickAllMembership}>
          {isEveryMembershipOff ? 'Subscribe to all' : 'Unsubscribe from all'}
        </Button>
      </div>
    </Fragment>
  );
}

export default Memberships;
